import React from 'react';

const JobQueuePageConfig: any = {
	settings: {
		layout: {
			config: {
				adminPage: true,
			},
		},
	},
	routes: [
		{
			path: '/admin/home/job-queue',
			exact: true,
			component: React.lazy(() => import('./JobQueuePage')),
		},
	],
};

export default JobQueuePageConfig;
